import Vue from 'vue';
import VueRouter from 'vue-router';
import {post} from '@/api';
import {encrypt} from '@/utils/crypto';

Vue.use(VueRouter);

window.addEventListener('popstate', () => {
    router.isBack = true
}, false);

const routes = [
    {
        name: 'template1',
        path: '/',
        component: resolve => require(['@/pages/Home/template1'], resolve),
    },
    {
        name: 'template1',
        path: '/template1',
        component: resolve => require(['@/pages/Home/template1'], resolve),
    },
    {
        name: 'template2',
        path: '/template2',
        component: resolve => require(['@/pages/Home/template2'], resolve),
    },
    {
        name: 'template3',
        path: '/template3',
        component: resolve => require(['@/pages/Home/template3'], resolve),
    }
];

const router = new VueRouter({mode: 'history', routes});
const timestamp = new Date().getTime() + '';
router.beforeEach((to, from, next) => {
    console.info(to.query.id)
    post('/WebSiteApi/selectTblWebsite', {
        id: to.query.id === undefined ? 321 : to.query.id,
        timestamp: timestamp,
        signature: encrypt(timestamp)
    }).then((res) => {
        console.log(res);
        if (res) {
            document.title = res.data.title;
            var link1 = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link1.type = 'image/x-icon';
            link1.rel = 'shortcut icon';
            link1.href = res.data.logoUrl;
            document.getElementsByTagName('head')[0].appendChild(link1);
            var link2 = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link2.type = 'image/x-icon';
            link2.rel = 'bookmark';
            link2.href = res.data.logoUrl;
            document.getElementsByTagName('head')[0].appendChild(link2);
        }
    })
    if (!to.meta.requireAuth) { //如果不需要路由校验
        next();
    } else {
        let openID = localStorage.getItem('openID');
        if (openID) {
            next();
        } else {
            next({path: '/home'});
        }
    }
});

export default router
